<template>
   <div class="app-container">
      <el-form :model="queryParams" ref="queryRef" v-show="showSearch" :inline="true" label-width="100px">
         <el-form-item :label="$t('systemRole.name')" prop="roleName">
            <el-input
               v-model="queryParams.roleName"
               :placeholder="$t('systemRole.name') + $t('global.plsInput')"
               clearable
               style="width: 240px"
               v-ctrl-enter="handleQuery"
            />
         </el-form-item>
         <el-form-item :label="$t('systemRole.permissionChar')" prop="roleKey" label-width="180px">
            <el-input
               v-model="queryParams.roleKey"
               :placeholder="$t('systemRole.permissionChar') + $t('global.plsInput')"
               clearable
               style="width: 320px"
               v-ctrl-enter="handleQuery"
            />
         </el-form-item>
         <el-form-item :label="$t('global.status')" prop="status">
          <keep-result-select
             style="width: 240px"
             :placeholder="$t('global.status') + $t('global.plsSelect')"
             v-model="queryParams.status"
             :list="sys_normal_disable"
          />
         </el-form-item>
         <el-form-item :label="$t('global.createTime')" style="width: 308px">
            <el-date-picker
               v-model="dateRange"
               value-format="YYYY-MM-DD"
               type="daterange"
               range-separator="-"
               :start-placeholder="$t('global.startDate')"
               :end-placeholder="$t('global.endDate')"
            ></el-date-picker>
         </el-form-item>
         <el-form-item>
            <el-button type="primary" icon="Search" @click="handleQuery">{{ $t('global.search') }}</el-button>
            <el-button icon="Refresh" @click="resetQuery">{{ $t('global.reset') }}</el-button>
         </el-form-item>
      </el-form>
      <el-row :gutter="10" class="mb8">
         <el-col :span="1.5">
            <el-button
               type="primary"
               plain
               icon="Plus"
               @click="handleAdd"
               v-hasPermi="['system:role:add']"
            >{{ $t('global.add') }}</el-button>
         </el-col>
         <!-- <el-col :span="1.5">
            <el-button
               type="success"
               plain
               icon="Edit"
               :disabled="single"
               @click="handleUpdate"
               v-hasPermi="['system:role:edit']"
            >{{ $t('global.edit') }}</el-button>
         </el-col> -->
         <el-col :span="1.5">
            <el-button
               type="danger"
               plain
               icon="Delete"
               :disabled="multiple"
               @click="handleDelete"
               v-hasPermi="['system:role:remove']"
            >{{ $t('global.delete') }}</el-button>
         </el-col>
         <el-col :span="1.5">
            <el-button
               type="warning"
               plain
               icon="Download"
               @click="handleExport"
               v-hasPermi="['system:role:export']"
            >{{ $t('global.export') }}</el-button>
         </el-col>
         <!-- <right-toolbar v-model:showSearch="showSearch" @queryTable="getList"></right-toolbar> -->
      </el-row>

      <!-- 表格数据 -->
      <el-table ref= "multipleTable" v-loading="loading" :data="roleList" @selection-change="handleSelectionChange">
         <el-table-column type="selection" width="55" align="center" :selectable="selectable" />
         <el-table-column :label="$t('systemRole.roleId')" prop="roleId" width="120" />
         <el-table-column :label="$t('systemRole.name')" prop="roleName" :show-overflow-tooltip="true" width="150" />
         <el-table-column :label="$t('systemRole.permissionChar')" prop="roleKey" :show-overflow-tooltip="true" width="150" />
         <el-table-column :label="$t('systemRole.roleSort')" prop="roleSort" width="100" />
         <el-table-column :label="$t('global.status')" align="center" width="100">
            <template #default="scope">
               <el-switch
                  v-model="scope.row.status"
                  active-value="0"
                  inactive-value="1"
                  @change="handleStatusChange(scope.row)"
               ></el-switch>
            </template>
         </el-table-column>
         <el-table-column :label="$t('global.createTime')" align="center" prop="createTime">
            <template #default="scope">
               <span>{{ parseTime(scope.row.createTime) }}</span>
            </template>
         </el-table-column>
         <el-table-column :label="$t('global.operation')" align="center" class-name="small-padding fixed-width">
            <template #default="scope">
              <el-tooltip :content="$t('global.edit')" placement="top" v-if="scope.row.roleId !== 1">
                <el-button link type="primary" icon="Edit" @click="handleUpdate(scope.row)" v-hasPermi="['system:role:edit']"></el-button>
              </el-tooltip>
              <el-tooltip :content="$t('global.delete')" placement="top" v-if="scope.row.roleId !== 1">
                <el-button link type="primary" icon="Delete" @click="handleDelete(scope.row)" v-hasPermi="['system:role:remove']"></el-button>
              </el-tooltip>
              <!-- <el-tooltip :content="$t('systemRole.dataper')" placement="top" v-if="scope.row.roleId !== 1">
                <el-button link type="primary" icon="CircleCheck" @click="handleDataScope(scope.row)" v-hasPermi="['system:role:edit']"></el-button>
              </el-tooltip> -->
              <el-tooltip :content="$t('systemRole.assignUser')" placement="top" v-if="scope.row.roleId !== 1">
                <el-button link type="primary" icon="User" @click="handleAuthUser(scope.row)" v-hasPermi="['system:role:edit']"></el-button>
              </el-tooltip>
            </template>
         </el-table-column>
      </el-table>

      <pagination
         v-show="total > 0"
         :total="total"
         v-model:page="queryParams.pageNum"
         v-model:limit="queryParams.pageSize"
         @pagination="getList"
      />

      <!-- 添加或修改角色配置对话框 -->
      <el-dialog :title="title" v-model="open" width="500px" append-to-body :close-on-click-modal="false">
         <el-form ref="roleRef" :model="form" :rules="rules" label-width="100px">
            <el-form-item :label="$t('systemRole.name')" prop="roleName">
               <el-input v-model="form.roleName" :placeholder="$t('systemRole.name') + $t('global.plsInput')" />
            </el-form-item>
            <el-form-item prop="roleKey" label-width="210px">
               <template #label>
                  <span>
                     <el-tooltip :content="$t('systemRole.permissionCharExample')" placement="top">
                        <el-icon><question-filled /></el-icon>
                     </el-tooltip>
                     {{ $t('systemRole.permissionChar') }}
                  </span>
               </template>
               <el-input v-model="form.roleKey" :placeholder="$t('systemRole.permissionChar') + $t('global.plsInput')" />
            </el-form-item>
            <el-form-item :label="$t('systemRole.roleSort')" prop="roleSort">
               <el-input-number v-model="form.roleSort" controls-position="right" :min="0" />
            </el-form-item>
            <el-form-item :label="$t('global.status')">
               <el-radio-group v-model="form.status">
                  <el-radio
                     v-for="dict in sys_normal_disable"
                     :key="dict.value"
                     :label="dict.value"
                  >{{ dict.label }}</el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('systemRole.menuPer')">
               <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event, 'menu')">{{ $t('global.collapse') }}</el-checkbox>
               <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event, 'menu')">{{ $t('systemRole.checked') }}</el-checkbox>
               <el-checkbox v-model="form.menuCheckStrictly" @change="handleCheckedTreeConnect($event, 'menu')">{{ $t('systemRole.parChild') }}</el-checkbox>
               <el-tree
                  class="tree-border"
                  :data="menuOptions"
                  show-checkbox
                  ref="menuRef"
                  node-key="id"
                  :check-strictly="!form.menuCheckStrictly"
                  :empty-text="$t('global.isLoading')"
                  :props="{ label: 'label', children: 'children' }"
               ></el-tree>
            </el-form-item>
            <el-form-item :label="$t('user.remark')" prop="remark">
               <el-input v-model="form.remark" type="textarea"></el-input>
            </el-form-item>
         </el-form>
         <template #footer>
            <div class="dialog-footer">
               <el-button type="primary" @click="submitForm">{{ $t('global.confirm') }}</el-button>
               <el-button @click="cancel">{{ $t('global.cancel') }}</el-button>
            </div>
         </template>
      </el-dialog>

      <!-- 分配角色数据权限对话框 -->
      <el-dialog :title="title" v-model="openDataScope" width="500px" append-to-body>
         <el-form :model="form" label-width="80px">
            <el-form-item :label="$t('systemRole.name')">
               <el-input v-model="form.roleName" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('systemRole.permissionChar')">
               <el-input v-model="form.roleKey" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('systemRole.permissionRange')">
               <el-select v-model="form.dataScope" @change="dataScopeSelectChange">
                  <el-option
                     v-for="item in dataScopeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
                  ></el-option>
               </el-select>
            </el-form-item>
            <el-form-item :label="$t('systemRole.dataper')" v-show="form.dataScope == 2">
               <el-checkbox v-model="deptExpand" @change="handleCheckedTreeExpand($event, 'dept')">{{ $t('global.collapse') }}</el-checkbox>
               <el-checkbox v-model="deptNodeAll" @change="handleCheckedTreeNodeAll($event, 'dept')">{{ $t('systemRole.checked') }}</el-checkbox>
               <el-checkbox v-model="form.deptCheckStrictly" @change="handleCheckedTreeConnect($event, 'dept')">{{ $t('systemRole.parChild') }}</el-checkbox>
               <el-tree
                  class="tree-border"
                  :data="deptOptions"
                  show-checkbox
                  default-expand-all
                  ref="deptRef"
                  node-key="id"
                  :check-strictly="!form.deptCheckStrictly"
                  :empty-text="$t('global.isLoading')"
                  :props="{ label: 'label', children: 'children' }"
               ></el-tree>
            </el-form-item>
         </el-form>
         <template #footer>
            <div class="dialog-footer">
               <el-button type="primary" @click="submitDataScope">{{ $t('global.confirm') }}</el-button>
               <el-button @click="cancelDataScope">{{ $t('global.cancel') }}</el-button>
            </div>
         </template>
      </el-dialog>
   </div>
</template>

<script setup name="Role">
import { useI18n } from 'vue-i18n';
import {
  addRole, changeRoleStatus, dataScope, delRole, getRole, listRole, updateRole, deptTreeSelect,
} from '@/api/system/role';
import { roleMenuTreeselect, treeselect as menuTreeselect } from '@/api/system/menu';
import selectMixin from '@/utils/useSelect.js';

const { t } = useI18n();
const router = useRouter();
const { proxy } = getCurrentInstance();
const { sys_normal_disable } = proxy.useDict('sys_normal_disable');

const roleList = ref([]);
const open = ref(false);
const loading = ref(true);
const showSearch = ref(true);
const ids = ref([]);
const single = ref(true);
const multiple = ref(true);
const total = ref(0);
const title = ref('');
const dateRange = ref([]);
const menuOptions = ref([]);
const menuExpand = ref(false);
const menuNodeAll = ref(false);
const deptExpand = ref(true);
const deptNodeAll = ref(false);
const deptOptions = ref([]);
const openDataScope = ref(false);
const menuRef = ref(null);
const deptRef = ref(null);
const isSyncingSelection = ref(false);
const multipleTable = ref(null);

/** 数据范围选项 */
const dataScopeOptions = ref([
  { value: '1', label: t('systemRole.allDataPer') },
  { value: '2', label: t('systemRole.cusDataPer') },
  { value: '3', label: t('systemRole.deptDataPer') },
  { value: '4', label: t('systemRole.deptChildDataPer') },
  { value: '5', label: t('systemRole.onlySelfDataPer') },
]);

const data = reactive({
  form: {},
  queryParams: {
    pageNum: 1,
    pageSize: 50,
    roleName: undefined,
    roleKey: undefined,
    status: undefined,
  },
  rules: {
    roleName: [{ validator: proxy.$validateEmpty(t('systemRole.name') + t('global.plsInput'), true), required: true, trigger: 'blur' }],
    roleKey: [{ validator: proxy.$validateEmpty(t('systemRole.permissionChar') + t('global.plsInput'), true), required: true, trigger: 'blur' }],
    roleSort: [
      {
        required: true, message: t('systemRole.roleSort') + t('global.plsInput'), trigger: 'blur',
      },
    ],
    remark: [
      { validator: proxy.$validateEmpty(), trigger: 'blur' },
    ],
  },
});

const { queryParams, form, rules } = toRefs(data);

function syncSelection() {
  proxy.$refs.multipleTable.clearSelection();
  roleList.value.forEach((row) => {
    if (ids.value.includes(row.roleId)) {
      proxy.$refs.multipleTable.toggleRowSelection(row, true);
    }
  });
}
/** 查询角色列表 */
function getList() {
  isSyncingSelection.value = true;
  loading.value = true;
  listRole(proxy.addDateRange(queryParams.value, dateRange.value)).then((response) => {
    roleList.value = response.rows;
    total.value = response.total;
    loading.value = false;
    proxy.$nextTick(() => {
      syncSelection();
      isSyncingSelection.value = false; // 重置标志
    });
  });
}
/** 搜索按钮操作 */
function handleQuery() {
  queryParams.value.pageNum = 1;
  getList();
}
/** 重置按钮操作 */
function resetQuery() {
  dateRange.value = [];
  proxy.resetForm('queryRef');
  handleQuery();
}
/** 删除按钮操作 */
function handleDelete(row) {
  const roleIds = row.roleId || ids.value;
  proxy.$modal.confirm(`${t('global.confirmDelete')}${roleIds}?`).then(function () {
    return delRole(roleIds);
  }).then(() => {
    getList();
    proxy.$modal.msgSuccess(proxy.$t('global.deleteSuccess'));
    ids.value = [];
    multiple.value = true;
  }).catch(() => {});
}
/** 导出按钮操作 */
function handleExport() {
  proxy.download('system/role/export', {
    ...queryParams.value,
  }, `role_${new Date().getTime()}.xlsx`);
}
/** 多选框选中数据 */
function handleSelectionChange(selection) {
  if (isSyncingSelection.value) return; // 在同步过程中，不处理选中状态变更
  const selectedIdsOnCurrentPage = roleList.value.map((item) => item.roleId);
  ids.value = ids.value
    .filter((id) => !selectedIdsOnCurrentPage.includes(id)) // 移除当前页面不再选中的ID
    .concat(selection.map((item) => item.roleId)); // 添加当前页面新选中的ID
  multiple.value = !ids.value.length;
}
/** 角色状态修改 */
function handleStatusChange(row) {
  const text = row.status === '0' ? t('global.on') : t('global.off');
  proxy.$modal.confirm(t('systemRole.confirmActiveRole', { text, roleName: row.roleName })).then(function () {
    return changeRoleStatus(row.roleId, row.status);
  }).then(() => {
    proxy.$modal.msgSuccess(text + proxy.$t('global.success'));
  }).catch(function () {
    row.status = row.status === '0' ? '1' : '0';
  });
}
/** 更多操作 */
function handleCommand(command, row) {
  switch (command) {
    case 'handleDataScope':
      handleDataScope(row);
      break;
    case 'handleAuthUser':
      handleAuthUser(row);
      break;
    default:
      break;
  }
}
/** 分配用户 */
function handleAuthUser(row) {
  router.push(`/system/role-auth/user/${row.roleId}`);
}
/** 查询菜单树结构 */
function getMenuTreeselect() {
  menuTreeselect().then((response) => {
    menuOptions.value = response.data;
  });
}
/** 所有部门节点数据 */
function getDeptAllCheckedKeys() {
  // 目前被选中的部门节点
  const checkedKeys = deptRef.value.getCheckedKeys();
  // 半选中的部门节点
  const halfCheckedKeys = deptRef.value.getHalfCheckedKeys();
  checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
  return checkedKeys;
}
/** 重置新增的表单以及其他数据  */
function reset() {
  if (menuRef.value != undefined) {
    menuRef.value.setCheckedKeys([]);
  }
  menuExpand.value = false;
  menuNodeAll.value = false;
  deptExpand.value = true;
  deptNodeAll.value = false;
  form.value = {
    roleId: undefined,
    roleName: undefined,
    roleKey: undefined,
    roleSort: 0,
    status: '0',
    menuIds: [],
    deptIds: [],
    menuCheckStrictly: true,
    deptCheckStrictly: true,
    remark: undefined,
  };
  proxy.resetForm('roleRef');
}
/** 添加角色 */
function handleAdd() {
  reset();
  getMenuTreeselect();
  open.value = true;
  title.value = t('systemRole.title') + t('global.add');
}
/** 修改角色 */
function handleUpdate(row) {
  reset();
  const roleId = row.roleId || ids.value;
  const roleMenu = getRoleMenuTreeselect(roleId);
  getRole(roleId).then((response) => {
    form.value = response.data;
    form.value.roleSort = Number(form.value.roleSort);
    open.value = true;
    nextTick(() => {
      roleMenu.then((res) => {
        const checkedKeys = res.checkedKeys;
        checkedKeys.forEach((v) => {
          nextTick(() => {
            menuRef.value.setChecked(v, true, false);
          });
        });
      });
    });
    title.value = t('systemRole.title') + t('global.edit');
  });
}
/** 根据角色ID查询菜单树结构 */
function getRoleMenuTreeselect(roleId) {
  return roleMenuTreeselect(roleId).then((response) => {
    menuOptions.value = response.menus;
    return response;
  });
}
/** 根据角色ID查询部门树结构 */
function getDeptTree(roleId) {
  return deptTreeSelect(roleId).then((response) => {
    deptOptions.value = response.depts;
    return response;
  });
}
/** 树权限（展开/折叠） */
function handleCheckedTreeExpand(value, type) {
  if (type == 'menu') {
    const treeList = menuOptions.value;
    for (let i = 0; i < treeList.length; i++) {
      menuRef.value.store.nodesMap[treeList[i].id].expanded = value;
    }
  } else if (type == 'dept') {
    const treeList = deptOptions.value;
    for (let i = 0; i < treeList.length; i++) {
      deptRef.value.store.nodesMap[treeList[i].id].expanded = value;
    }
  }
}
/** 树权限（全选/全不选） */
function handleCheckedTreeNodeAll(value, type) {
  if (type == 'menu') {
    menuRef.value.setCheckedNodes(value ? menuOptions.value : []);
  } else if (type == 'dept') {
    deptRef.value.setCheckedNodes(value ? deptOptions.value : []);
  }
}
/** 树权限（父子联动） */
function handleCheckedTreeConnect(value, type) {
  if (type == 'menu') {
    form.value.menuCheckStrictly = !!value;
  } else if (type == 'dept') {
    form.value.deptCheckStrictly = !!value;
  }
}
/** 所有菜单节点数据 */
function getMenuAllCheckedKeys() {
  // 目前被选中的菜单节点
  const checkedKeys = menuRef.value.getCheckedKeys();
  // 半选中的菜单节点
  const halfCheckedKeys = menuRef.value.getHalfCheckedKeys();
  checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
  return checkedKeys;
}
/** 提交按钮 */
function submitForm() {
  proxy.$refs.roleRef.validate((valid) => {
    if (valid) {
      if (form.value.roleId != undefined) {
        form.value.menuIds = getMenuAllCheckedKeys();
        updateRole(form.value).then((response) => {
          proxy.$modal.msgSuccess(proxy.$t('global.editSuccess'));
          open.value = false;
          getList();
        });
      } else {
        form.value.menuIds = getMenuAllCheckedKeys();
        addRole(form.value).then((response) => {
          proxy.$modal.msgSuccess(proxy.$t('global.addSuccess'));
          open.value = false;
          getList();
        });
      }
    }
  });
}
/** 取消按钮 */
function cancel() {
  open.value = false;
  reset();
}
/** 选择角色权限范围触发 */
function dataScopeSelectChange(value) {
  if (value !== '2') {
    deptRef.value.setCheckedKeys([]);
  }
}
/** 分配数据权限操作 */
function handleDataScope(row) {
  reset();
  const deptTreeSelect = getDeptTree(row.roleId);
  getRole(row.roleId).then((response) => {
    form.value = response.data;
    openDataScope.value = true;
    nextTick(() => {
      deptTreeSelect.then((res) => {
        nextTick(() => {
          if (deptRef.value) {
            deptRef.value.setCheckedKeys(res.checkedKeys);
          }
        });
      });
    });
    title.value = t('systemRole.assignDataPer');
  });
}
/** 提交按钮（数据权限） */
function submitDataScope() {
  if (form.value.roleId != undefined) {
    form.value.deptIds = getDeptAllCheckedKeys();
    dataScope(form.value).then((response) => {
      proxy.$modal.msgSuccess(proxy.$t('global.editSuccess'));
      openDataScope.value = false;
      getList();
    });
  }
}
/** 取消按钮（数据权限） */
function cancelDataScope() {
  openDataScope.value = false;
  reset();
}

function selectable(row, index) {
  return !row.admin;
}
getList();
</script>
